module.exports = __webpack_public_path__ + "img/bigsellCN.4492de5c.png";